import { createChatDashboardData, createEmailDashboardData, createRealtimeDashboardTimeframeStats, createRealtimeRecordAgentStats } from "..";
import { ActivityType } from "../../domain";
import { RandomGenerator } from "../../test-utils";
export var createOmniDashboardData = function (itemsLength, activityType) {
    if (itemsLength === void 0) { itemsLength = 5; }
    var chatDashboardItems = createChatDashboardData(1).items;
    var emailDashboardItems = createEmailDashboardData(1).items;
    var itemName = "".concat(activityType || RandomGenerator.selectRandom([ActivityType.CHAT, ActivityType.TICKETING]));
    var items = new Array(itemsLength).fill(0).map(function (_) { return ({
        realtimeData: {
            totalWaiting: RandomGenerator.randomNumber(1),
            totalActive: RandomGenerator.randomNumber(1),
            longestWaitingTicket: {
                ticketId: RandomGenerator.randomTicket().id,
                statusStartDate: 1623847737018
            },
            totalAllWaiting: RandomGenerator.randomNumber(1),
        },
        itemName: itemName,
        itemId: undefined,
        agentStats: createRealtimeRecordAgentStats(),
        timeframeStats: createRealtimeDashboardTimeframeStats(),
        subRows: itemName === "".concat(ActivityType.CHAT) ? chatDashboardItems : emailDashboardItems
    }); });
    return ({
        items: items,
        itemsCount: itemsLength,
    });
};
export var createOmniDashboardStats = function () {
    return ({
        realtimeData: {
            totalWaiting: RandomGenerator.randomNumber(),
            totalActive: RandomGenerator.randomNumber(),
            longestWaitingTicket: {
                ticketId: RandomGenerator.randomTicket().id,
                statusStartDate: 1623847737018
            },
            totalAllWaiting: RandomGenerator.randomNumber(1),
        },
        agentStats: createRealtimeRecordAgentStats(),
        timeframeStats: createRealtimeDashboardTimeframeStats()
    });
};
//# sourceMappingURL=builders.js.map